import { useRef, useState } from "react";
import { gsap, useGSAP, MOTION_OK, sel } from "../lib/motion";
import { profile } from "../data/profile";
import s from "./Intro.module.css";

const KEY = "intro-seen";

/** Whether the intro curtain will play on this load (once per browser session). */
export function introWillPlay() {
  try {
    return !sessionStorage.getItem(KEY) && window.matchMedia(MOTION_OK).matches;
  } catch {
    return false;
  }
}

/** Seconds the hero should wait before its own choreography starts. */
export const INTRO_DELAY = 1.15;

export default function Intro() {
  const root = useRef<HTMLDivElement>(null);
  const [play] = useState(introWillPlay);
  const [done, setDone] = useState(!play);

  useGSAP(
    () => {
      if (!play) return;
      try {
        sessionStorage.setItem(KEY, "1");
      } catch {
        /* private mode */
      }
      const tl = gsap.timeline({ defaults: { ease: "expo.inOut" }, onComplete: () => setDone(true) });
      tl.from(`${sel(s.word)} span`, { yPercent: 110, duration: 0.8, stagger: 0.06, ease: "expo.out" }, 0.1)
        .to(`${sel(s.word)} span`, { yPercent: -110, duration: 0.6, stagger: 0.04, ease: "expo.in" }, 0.95)
        .to(root.current, { clipPath: "inset(0 0 100% 0)", duration: 0.9 }, 1.05);
    },
    { scope: root }
  );

  if (done) return null;

  return (
    <div ref={root} className={s.curtain} aria-hidden="true">
      <p className={s.word}>
        {profile.name.split(" ").map((w) => (
          <span key={w} className={s.line}>
            <span>{w}</span>
          </span>
        ))}
      </p>
    </div>
  );
}
